import React from "react";

const PaginationControls = ({ currentPage, totalPaginationCount, itemsPerPage, changePage, loader }) => {
  const startIndex = (currentPage - 1) * itemsPerPage;
  const startEmailIndex = startIndex + 1;
  const endEmailIndex = Math.min(currentPage * itemsPerPage, totalPaginationCount);
  return (
    <>
      {totalPaginationCount > 10 && (
        <div
          className="item-2"
        >
          <div style={{display:"flex", alignItems:"baseline", gap:"8px"}}> 
            <p>{`${startEmailIndex}-${endEmailIndex} of ${totalPaginationCount}`}</p>
            <button
              className="pagination-btn"
              onClick={() => changePage("prev")}
              disabled={currentPage === 1 || loader}
            >
              {"<"}
            </button>
            <button
              className="pagination-btn"
              onClick={() => changePage("next")}
              disabled={endEmailIndex === totalPaginationCount || loader}
            >
              {">"}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default PaginationControls;
